import axios from 'axios';
import useSWR from 'swr';

const fetcher = (url: string, config: any) =>
  axios.get(url, config).then(res => res.data);

const useFeaturedCars = () => {
  const { data: featuredCars, isValidating: isFeaturedValidating } = useSWR(
    '/api/featured-cars',
    fetcher,
  );

  return {
    data: featuredCars,
    isValidating: isFeaturedValidating,
  };
};

export default useFeaturedCars;
